export const LOGIN_TYPES_BY_COUNTRY = {
  LT: ['BioFace', 'SmartId', 'MSignature'],
  LV: ['BioFace', 'SmartId', 'lv-eparaksts'],
  EE: ['BioFace', 'SmartId', 'MSignature'],
  NL: ['BioFace', { label: 'IDIN', loginType: 'idin-customer', icon: 'IDIN' }],
  FI: ['BioFace', { label: 'FTN', loginType: 'fi-id', icon: 'FTN' }],
  Other: ['BioFace', 'SmartId', 'MSignature', 'lv-eparaksts', { label: 'FTN', loginType: 'fi-id', icon: 'FTN' }, { label: 'IDIN', loginType: 'idin-customer', icon: 'IDIN' }],
};
